import React,{useState,useEffect}  from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './member_dashboard.css';

export const Member_Dashboard=(props)=>{
    useEffect(()=>{
      
        //alert(JSON.stringify(props.dashboardData));
      
    },[props.dashboardData]);
    return(<>{1>0?
    <div class="row">
              <div class="col-12 col-sm-12 col-md-3">
                <Link to={'/intrested_member'}> 
                <div class="info-box">
                  <span class="info-box-icon bg-info elevation-1">
                    {/* <i class="fas fa-cog white"></i> */}
                    <i class="fa fa-save white"></i>
                    </span>
    
                  <div class="info-box-content">
                    <span class="info-box-text">Total Request</span>
                    <span class="info-box-number">
                     
                      <small>{props.dashboardData?.member_reqests?.Total}</small>
                    </span>
                  </div>
                  
                </div>
                </Link>
              </div>
              
              <div class="col-12 col-sm-12 col-md-3">
              <Link to={'/intrested_member'}>
                <div class="info-box mb-3">
                  <span class="info-box-icon bg-danger elevation-1">
                    <i class="fa fa-thumbs-up white"></i>
                    </span>
    
                  <div class="info-box-content">
                    <span class="info-box-text">Accepted Request</span>
                    <span class="info-box-number">
                    <small>{props.dashboardData?.member_reqests?.Accepted}</small>
                    </span>
                  </div>
                  
                </div>
               </Link>
              </div>

              <div class="col-12 col-sm-12 col-md-3">
           <Link to={"/intrested_member"}>
            <div class="info-box mb-3">
              <span class="info-box-icon bg-warning"><i class="fa fa-tag white"></i></span>

              <div class="info-box-content">
                <span class="info-box-text">Pending Request</span>
                <span class="info-box-number">
                <small>{props.dashboardData?.member_reqests?.Pending}</small>
                </span>
              </div>
              
            </div>
            </Link>
            </div>

            {/* Intro Video */}
            <div class="col-12 col-sm-12 col-md-3">
              <Link to={"/search_matching"}>
            <div class="info-box mb-3">
              <span class="info-box-icon bg-danger"><i class="fa fa-search white"></i></span>

              <div class="info-box-content">
                <span class="info-box-text"></span>
                <span class="info-box-number">{"Search Members"}</span>
              </div>
              
            </div>
            </Link>
            </div>
             
              {/* <div class="clearfix hidden-md-up"></div> */}
              {/* goal completion */}
              <div class="col-12 col-md-12 mt-10 ">
              <div class="progress-group">
                      Profile Completion for best visibility and ratings
                      <span class="float-right"><b>{"rank"}</b>/{"totalRank"}</span>
                      <div class="progress progress-sm">
                        <div class="progress-bar bg-danger" style={{"width":"20"+"%"}}></div>
                      </div>
                    </div>
                    
<ul class="nav nav-pills nav-sidebar flex-column">
  {/* {stprofileList.map((item,index)=>{
    return  <li class="nav-item">
    <Link to={'/profile'} class="nav-link">
      <i class="nav-icon far fa-circle text-warning"></i>
      <p>{item}</p>
    </Link>
  </li>
  })} */}
                   

          </ul>
          

            </div>        
              
            </div>:''}</>);

}
export default Member_Dashboard;